module.exports = __webpack_public_path__ + "static/assets/410ccbdf0bbd12597c7152f64d44afca.jpg";